"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const masterData_json_1 = require("../masterData.json");
/**
 * Calculate the monthly coefficient index from the date.
 * @param date The date.
 */
const getIndex = (date) => {
    const from = new Date(-3058300800000);
    const to = new Date(date);
    return (to.getMonth() -
        from.getMonth() +
        12 * (to.getFullYear() - from.getFullYear()));
};
/** Get the monthly coefficient corresponding to the specified date. */
exports.default = (date) => { var _a; return (_a = masterData_json_1.monthlyCoefficients[getIndex(date)]) !== null && _a !== void 0 ? _a : Number.NaN; };
//# sourceMappingURL=getMonthlyCoefficients.js.map